<script lang="ts">
	import { onMount } from 'svelte';
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
	}

	let { config }: Props = $props();
	let copyrightText = $state('');

	onMount(() => {
		const currentYear = new Date().getFullYear();
		const startYear = 2025;
		const copyrightOwner = config.copyrightOwner || 'Artificer Innovations, LLC';

		if (currentYear === startYear) {
			copyrightText = `© ${startYear} ${copyrightOwner}, All rights reserved.`;
		} else {
			copyrightText = `© ${startYear}-${currentYear} ${copyrightOwner}, All rights reserved.`;
		}
	});
</script>

<div class="copyright">{copyrightText}</div>

<style>
	.copyright {
		font-weight: 400;
		color: white;
		opacity: 0.8;
		font-size: small;
		text-align: center;
		width: 100%;
		min-height: 1em;
	}
</style>
